import { Card, DatePicker, Input, Modal, Radio, Select, Segmented, Spin, Tabs, Tag, Tooltip, message } from 'antd';
import { FrownOutlined, MehOutlined, SettingOutlined, SmileOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import './GoogleReviews.css';
import '../../pages.scss';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import { Synchronized } from '../../../components/design/Synchronized/Synchronized';
import { SCHEDULEDJOB } from '../../../../common/constants/services';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { LabelIADrawer } from './Reviews/drawer/LabelIADrawer';
import { useTranslation } from 'react-i18next';
import SelectPeriod from '../../../components/model/selectMonths/SelectPeriod';
import { CommentsList } from './CommentsList';
import { CommentsByLocation } from './CommentsByLocation';
import { LABEL_COLOR } from './Reviews/Label';
import { ModuleAccessGate } from '../../common/roles/ModuleAccessGate';
import { PageTitle } from '../../common/PageTitle';
import { PageFilters, PageFilterField } from '../../common/PageFilters';

const SENTIMENT_PAGE_INFO = 'Analiza el contenido de las reseñas que dejan tus clientes, y esto va más allá de un estudio puramente cualitativo, nos ayudamos de la IA para etiquetar analizar el sentimiento de las reseñas en base al texto. Este etiquetado se basa en categorías configurables desde esta misma pantalla que añaden un contexto a la etiqueta y permite por una parte facilitar el análisis ... que es mucho más que una nube de palabras y por otra parte permite filtrar el tipo de información que queremos analizar.';

export const CommentsPage = () => (
	<ModuleAccessGate module='SENTIMENT_ANALYSIS' title='Análisis de sentimiento' pageInfo={SENTIMENT_PAGE_INFO}>
		<CommentsPageContent />
	</ModuleAccessGate>
);

const CommentsPageContent = () => {

	const [updateData, setUpdateData] = useState(false);
	const [openDrawer, setOpenDrawer] = useState(false);    
	const [categories, setCategories] = useState([]);    	
    const [filterCategory, setFilterCategory] = useState('');
    const [filterPeriod, setFilterPeriod] = useState('LAST_30DAYS');    
    const [filterSentiment, setFilterSentiment] = useState('');
    const [filterLabeled, setFilterLabeled] = useState('');
	
    const { t } = useTranslation();

    const [activeTab, setActiveTab] = useState("1"); 
    const { projectGroup, getGroupName } = useAuth();		
	
	const esTodosLosGrupos = getGroupName() === 'Todos los Grupos';

    const handleTabChange = (key: string) => {
        setActiveTab(key);
        console.log('Active Tab:', key); // Optional: Log the active tab
    };

	/*const handleChangeYearMonth = (date: any, dateString: string) => {
		setFilterMonth('filterMonth=' + date.format('YYYY-MM'));			
	};*/
	  
	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/category`
	  	, {},[updateData]
		,(data) => {      
			setCategories(data);					
		}
        );

    const handleChangeCategory = (category: string) => {
        setFilterCategory('&filterCategory=' + category);			
    };	

	return (
		<>
			<Card className='main-card-content' >

				<Synchronized service={[SCHEDULEDJOB.GBP_REVIEWS]} />
				<div style={{display:'flex', color:'slategray', justifyContent:'space-between', alignItems:'center', marginBottom: '10px'}}>
                    <PageTitle
						title='Análisis de sentimiento'
						pageInfo={SENTIMENT_PAGE_INFO}
						extra={
							esTodosLosGrupos ? (
								<Tooltip
									color='transparent'
									overlayInnerStyle={{ padding: 0, boxShadow: 'none' }}
									title={
										<span style={{
											display: 'inline-block',
											padding: '10px 14px',
											borderRadius: 10,
											background: '#fffbeb',
											border: '1px solid #fcd34d',
											color: '#b45309',
											fontSize: 13,
											fontWeight: 500,
											lineHeight: 1.5,
											maxWidth: 280,
										}}>
											Debes seleccionar un grupo de Google en la cabecera, cada grupo tiene su propia configuración
										</span>
									}
								>
									<span>
										<ButtonLZ
											disabled
											type='dashed'
											style={{
												borderColor: 'slategrey',
												backgroundColor: 'ghostwhite',
												cursor: 'not-allowed',
												transition: 'all 0.3s',
											}}
										>
											<div style={{ color: 'slategrey', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 500 }}>
												<SettingOutlined />
												Etiquetar con IA
											</div>
										</ButtonLZ>
									</span>
								</Tooltip>
							) : (
								<ButtonLZ
									type='default'
									onClick={() => { setOpenDrawer(true); }}
								>
									<div style={{ color: 'black', display: 'flex', alignItems: 'center', gap: '6px' }}>
										<SettingOutlined />
										Etiquetar con IA
									</div>
								</ButtonLZ>
							)
						}
					/>
                </div>
				<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 4 }}>
					<PageFilters>
						<PageFilterField label='Categoría' active={!!filterCategory && filterCategory !== '&filterCategory=ALL'}>
							<Select
								size='small'
								bordered={false}
								showSearch
								optionFilterProp='label'
								defaultValue='ALL'
								style={{ minWidth: 160, fontWeight: 500 }}
								placeholder='Todas'
								onChange={(value: string) => { handleChangeCategory(value); }}
								options={[
									{ value: 'ALL', label: 'Todas' },
									...(categories?.map((label: any) => ({
										value: label.name,
										label: label.name,
									})) ?? []),
								]}
							/>
						</PageFilterField>
						<PageFilterField label='Etiquetado' active={filterLabeled !== ''}>
							<Radio.Group size='small' value={filterLabeled} optionType="button" buttonStyle="outline"
								onChange={(obj: any) => {setFilterLabeled(obj.target.value)}}>
								<Radio.Button value=''>Todos</Radio.Button>
								<Radio.Button value='&filterLabeled=true'>Etiquetado</Radio.Button>
								<Radio.Button value='&filterLabeled=false'>Pendiente</Radio.Button>
							</Radio.Group>
						</PageFilterField>
						<PageFilterField label='Sentimiento' active={filterSentiment !== ''}>
							<Radio.Group
								className='page-filters-sentiment'
								size='small'
								value={filterSentiment}
								optionType="button"
								buttonStyle="outline"
								onChange={(obj: any) => {setFilterSentiment(obj.target.value)}}
							>
								<Radio.Button value=''>Todos</Radio.Button>
								<Radio.Button value='&filterSentiment=NEGATIVE'><FrownOutlined style={{ fontSize: 16, color: LABEL_COLOR.NEGATIVE }} /></Radio.Button>
								<Radio.Button value='&filterSentiment=NEUTRAL'><MehOutlined style={{ fontSize: 16, color: LABEL_COLOR.NEUTRAL }} /></Radio.Button>
								<Radio.Button value='&filterSentiment=POSITIVE'><SmileOutlined style={{ fontSize: 16, color: LABEL_COLOR.POSITIVE }} /></Radio.Button>
							</Radio.Group>
						</PageFilterField>
						<PageFilterField label='Periodo' active>
							<SelectPeriod setSelectedType={setFilterPeriod} defaultValue={filterPeriod} maxMonths={3}/>
						</PageFilterField>
					</PageFilters>
				</div>

                <Tabs activeKey={activeTab} onChange={handleTabChange} type="line" style={{ width: '100%', marginTop: 0 }} >

                    <Tabs.TabPane tab={<span className='title-tabPane'>Etiquetar reseñas</span>} key="1">
                        {activeTab == '1' && <CommentsList filterCategory={filterCategory} filterSentiment={filterSentiment} filterLabeled={filterLabeled} filterPeriod={'&filterPeriod=' + filterPeriod} categories={categories}/>}
                    </Tabs.TabPane>

                    <Tabs.TabPane tab={<span className='title-tabPane'>Analizar etiquetas</span>} key="2">                    
                        {activeTab == '2' && <CommentsByLocation filterCategory={filterCategory} filterSentiment={filterSentiment} filterLabeled={filterLabeled} filterPeriod={'&filterPeriod=' + filterPeriod} categories={categories}/>}
                    </Tabs.TabPane>
                </Tabs>   
            { openDrawer && <LabelIADrawer onClose={() => {setUpdateData(!updateData); setOpenDrawer(false);}}/> }            
			</Card>
		</>
	)
}